import React from 'react';
import { motion } from 'framer-motion';
import { Reveal, RevealLines } from './Reveal';
import { PRESTATIONS } from '../data/site';
import { ArrowUpRight } from 'lucide-react';

const INCLUDED = [
  'Installation du bar mobile',
  'Verrerie & matériel professionnel',
  'Barman expérimenté',
  'Cocktails classiques ou créations',
  'Service personnalisé',
  'Devis gratuit & sur mesure',
];

export default function Prestations() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="prestations" className="relative py-32 md:py-48 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="prestations-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-20">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="flex md:flex-col items-baseline md:items-start gap-4">
            <span className="font-mono text-gold text-sm tracking-[0.3em]">02 —</span>
            <span className="overline">Nos prestations</span>
          </div>
        </Reveal>
        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
            <RevealLines lines={['Sept occasions.', <span key="i" className="italic text-char/50">Une même exigence.</span>]} />
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-char/10">
        {PRESTATIONS.map((p, i) => (
          <motion.button
            key={p.n}
            onClick={() => scrollTo('contact')}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.7, 0, 0.2, 1] }}
            whileHover={{ y: -4 }}
            className={`group relative bg-cream p-8 md:p-10 text-left overflow-hidden ${i === PRESTATIONS.length - 1 ? 'lg:col-span-2' : ''}`}
            data-testid={`prestation-${p.n}`}
          >
            <div className="flex items-start justify-between mb-16">
              <span className="font-mono text-gold text-xs tracking-[0.3em]">{p.n}</span>
              <ArrowUpRight
                size={18}
                className="text-char/30 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform duration-500"
              />
            </div>
            <div className="font-serif text-3xl md:text-4xl leading-none">{p.title}</div>
            <div className="mt-3 text-sm text-char/60 leading-relaxed">{p.desc}</div>
            <span className="absolute bottom-0 left-0 h-px w-0 bg-gold group-hover:w-full transition-all duration-700" />
          </motion.button>
        ))}
      </div>

      {/* Included list */}
      <div className="mt-20 grid grid-cols-12 gap-6 md:gap-10">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="overline">Chaque prestation inclut</div>
        </Reveal>
        <div className="col-span-12 md:col-span-9 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
          {INCLUDED.map((it, i) => (
            <Reveal key={it} delay={i * 0.05}>
              <div className="flex items-center gap-4 py-3 border-b border-char/10">
                <span className="font-mono text-gold text-xs">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-char/85">{it}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
